import { OSType, PlatformType } from '@invideoio/web-shared/constants/common';
import {
  createDraftSafeSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { AppState } from '@store/store';

export interface DeviceState {
  os: string;
  platform: PlatformType;
}

// INITIAL TIMER STATE
const initialDeviceState: DeviceState = {
  os: '',
  platform: PlatformType.Desktop,
};

// TIMER REDUCER
const deviceSlice = createSlice({
  name: 'user',
  initialState: initialDeviceState,
  reducers: {
    SET_OS: (state, action) => {
      return {
        ...state,
        os: action.payload,
      };
    },
    SET_PLATFORM: (state, action: PayloadAction<PlatformType>) => {
      return {
        ...state,
        platform: action.payload,
      };
    },
  },
});

export const osStateSelector = createDraftSafeSelector(
  (state: AppState) => state.device,
  state => state.os,
);

export const platformStateSelector = createDraftSafeSelector(
  (state: AppState) => state.device,
  state => state.platform,
);

export const deviceStateSelector = createDraftSafeSelector(
  (state: AppState) => state.device,
  state => state,
);

export const { SET_OS, SET_PLATFORM } = deviceSlice.actions;

export default deviceSlice.reducer;
